import 'waypoints/lib/noframework.waypoints.min.js';

import {initNav} from './nav-fold';
import {randomColor} from './random-color';
import {initPreloader} from './preloader';
import {initCart} from './shopping_cart';
import {addListenersFormFooter} from './form_newsletter_footer';

let debug = true;
function disableLogger() {
	window['console']['log'] = function() {};
}

function interactive() {
	if(!debug) disableLogger();
	randomColor();
	initNav();
	initCart();
	addListenersFormFooter();
}

function complete() {
	initPreloader.play();
}


document.addEventListener('readystatechange', (event) => {
	switch (document.readyState) {
		case "loading":
			break;
		case "interactive":
			interactive();
			break;
		case "complete":
			complete();
			break;
	}
});